import type {
  GetReportingFlagsResponse,
  GetReportingFlagsResponseAPI,
} from '@omnipresentgroup/types';

/**
 * Transform the API response to the internal format
 * @param response API response
 * @returns Transformed response
 */
export const transformReportingFlagsFromAPI = (
  response: GetReportingFlagsResponseAPI,
): GetReportingFlagsResponse => ({
  enablePayrollReportsTab: response.enable_payroll_reports_tab,
});
